import { integrationMiddleware } from "../network/middlewareHttp";
import { baseURL } from "./FetchUrl";

class StatusCatalog{
    apiURL = baseURL
    getEndpoint = '/api/Status/get'
    postEndpoint = '/api/Status/post'
    putEndpoint = '/api/Status/put'
    deleteEndpoint = '/api/Status/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')

    getStatusList = async(filter) => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint + "?filter=" + (filter ? "true" : "false"))
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postStatus = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteStatus = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateStatus = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default StatusCatalog
